import { useState, useEffect, useCallback } from 'react';

interface StorageItemHookProps {
  key: string;
}
export const useStorageItem = <T extends object>({
  key,
}: StorageItemHookProps) => {
  const [stored, setStored] = useState<T | undefined>(undefined);
  useEffect(() => {
    try {
      const fetchItem = localStorage.getItem(key);
      setStored(fetchItem ? (JSON.parse(fetchItem) as T) : undefined);
    } catch (error) {
      console.error({ getItem: key }, error);
      setStored(undefined);
    }
  }, [key]);

  const setStorageItem = useCallback(
    (update: Partial<T> | ((prev: T) => T)) => {
      setStored((prev) => {
        const updateValue =
          typeof update === 'function'
            ? (update as (prev: T | undefined) => T)(prev as T)
            : { ...(prev as T), ...update };
        return updateValue;
      });
    },
    [],
  );

  useEffect(() => {
    try {
      stored !== undefined
        ? localStorage.setItem(key, JSON.stringify(stored))
        : localStorage.setItem(key, JSON.stringify({}));
    } catch (error) {
      console.error({ setItem: key }, error);
    }
  }, [key, stored]);
  return { stored, setStorageItem };
};
